import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import NewCollectionModal from "./NewCollectionModal";
import {
  addToCollection,
  getAllCollections,
  removeFromCollection,
} from "../../../store/userCollectionsSlice/collections-actions";

import { AiOutlinePlus } from "react-icons/ai";
import { AiOutlineMinus } from "react-icons/ai";

import classes from "./CollectionModal.module.css";

const CollectionModal = ({ onClose, id, url, username, name, link }) => {
  const [modelOpen, setModelOpen] = useState(false);
  const collections = useSelector((state) => state.collections.collections);
  const status = useSelector((state) => state.collections.loading);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllCollections());
  }, [dispatch, status]);

  const addToCollectionHandler = ({colId, colName}) => {
    dispatch(
      addToCollection({ collectionId: colId, id, url, username, name, link, colName })
    );
  };
  const removeFromCollectionHandler = ({ colId, colName }) => {
    dispatch(removeFromCollection({ id: colId, imageId: id, name, colName }));
  };

  const openNewCollection = () => {
    setModelOpen(true);
  };
  const closeNewCollection = () => {
    setModelOpen(false);
  };
  return (
    <>
      <div className={classes.backdrop} onClick={onClose} />
      <div className={classes.overlay}>
        <img src={url} alt="opened img used as placeholder" />
        <div className={classes.input}>
          <h2 className={classes.title}>Add to collection</h2>
          <button
            className={`${classes.button} ${classes[`new-collection`]}`}
            onClick={openNewCollection}
          >
            Create new Collection
          </button>
          <ul className={classes.list}>
            {collections.length > 0 &&
              collections.map((col) => {
                const includes = col.images.map((img) => img.id).includes(id);
                return (
                  <li key={col._id}>
                    <button
                      className={`${classes.button} ${
                        includes ? classes.highlight : ""
                      }`}
                      type="button"
                      onClick={
                        includes
                          ? () =>
                              removeFromCollectionHandler({
                                colId: col._id,
                                colName: col.name,
                              })
                          : () =>
                              addToCollectionHandler({
                                colId: col._id,
                                colName: col.name,
                              })
                      }
                    >
                      <span className={classes.count}>
                        {col.images.length} photo
                        {col.images.length === 1 ? "" : "s"}
                      </span>
                      <span className={classes.name}>{col.name}</span>
                      {includes ? (
                        <AiOutlineMinus size={20} />
                      ) : (
                        <AiOutlinePlus size={20} />
                      )}
                    </button>
                  </li>
                );
              })}
          </ul>
          <div className={classes.actions}>
            <button
              type="button"
              onClick={onClose}
              className={classes[`sec-btn`]}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      {modelOpen && <NewCollectionModal close={closeNewCollection} url={url} />}
    </>
  );
};

export default CollectionModal;
